'use client';

import React from 'react';
import { useTranslation } from 'next-i18next';


/**
 * HowItWorks - Step-by-step guide for the Audio Interview feature
 */
export const HowItWorks: React.FC = () => {
  const { t } = useTranslation('common');

  const steps = [
    {
      title: t('audio-interview.how-it-works.connect'),
      description: t('audio-interview.how-it-works.connect.description'),
    },
    {
      title: t('audio-interview.how-it-works.conversation'),
      description: t('audio-interview.how-it-works.conversation.description'),
    },
    {
      title: t('audio-interview.how-it-works.processing'),
      description: t('audio-interview.how-it-works.processing.description'),
    },
  ];

  return (
    <div className="max-w-md">
      <div className="rounded-2xl bg-surface-100 p-8 shadow-lg">
        <h3 className="mb-6 text-2xl font-semibold text-ink">
          {t('audio-interview.how-it-works')}
        </h3>
        <div className="space-y-6">
          {steps.map((step, index) => (
            <div key={step.title} className="flex items-start space-x-4">
              <div className="flex size-10 items-center justify-center rounded-full bg-primary text-lg font-semibold text-white">
                {index + 1}
              </div>
              <div className="flex-1">
                <h4 className="mb-2 text-lg font-medium text-ink">{step.title}</h4>
                <p className="text-ink-medium">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

